function VoucherInfo({ voucherNo, date, setDate, onPrintVoucher }) {
  return (
    <div className="bg-white border border-[#e2e8f0] rounded-xl p-4">
      <p className="text-xs font-bold text-slate-500 uppercase tracking-wide mb-3">
        Voucher Info
      </p>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="text-xs font-medium text-slate-600 block mb-1">
            Voucher Number
          </label>
          <div className="relative">
            <input
              type="text"
              value={voucherNo}
              readOnly
              className="w-full h-9 px-3 text-sm bg-slate-50 border border-[#e2e8f0] rounded-lg text-slate-500 cursor-not-allowed pr-10"
            />
            {voucherNo && voucherNo !== '—' && (
              <button
                onClick={() => onPrintVoucher?.(voucherNo)}
                className="absolute right-1 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center rounded hover:bg-slate-200 text-slate-400 hover:text-slate-600 transition-colors cursor-pointer"
                title="Print Voucher"
              >
                <i className="ri-printer-line text-sm" />
              </button>
            )}
          </div>
        </div>
        <div>
          <label className="text-xs font-medium text-slate-600 block mb-1">
            Payment Date
          </label>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className="w-full h-9 px-3 text-sm border border-[#e2e8f0] rounded-lg focus:outline-none focus:border-[#4f46e5]"
          />
        </div>
      </div>
    </div>
  );
}

export default VoucherInfo;
